import { Spinner } from "react-bootstrap";
import Icon from "./Icon";

interface BoxStatisticsProps {
  color: string,
  label: string,
  icon: string,
  value: any,
}

const BoxStatistics = ({
  color = "rgb(95, 181, 235)",
  label = "",
  icon = "",
  value = null,
}: BoxStatisticsProps) => {

  if (value == null) {
    value = <Spinner />
  }

  return (
    <div className="boxStatistics d-flex">
      <div className="d-inline-block">
        <div className="ball" style={{ background: color }}>
          <Icon color={"#fff"} icon={icon} />
        </div>
      </div>
      <div className="d-inline-block">
        <h3 style={{ color: color }}>{value}</h3>
        <p>{label}</p>
      </div>
    </div>
  )
}

export default BoxStatistics